<!--
 * @Description: 模块管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-29 10:51:17
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-05-21 10:23:29
 -->
<template>
  <div class="moduleMana">
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">模块管理</div>
        <div class="handleArea">
          <el-button class="addButton" icon="el-icon-circle-plus-outline" type="danger" round @click="add">新增</el-button>
        </div>
      </div>
      <div class="moduleTree">
        <el-tree
          :data="superModuleTree"
          node-key="id"
          default-expand-all
          :props="superModuleTreeProps"
          :expand-on-click-node="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button
                type="text"
                size="mini"
                class="detailBtn el-icon-document"
                @click.stop="showDetail(node, data)">
                详情
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="addBtn el-icon-circle-plus-outline"
                @click.stop="add(node, data)">
                新增
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="modifyBtn el-icon-edit-outline"
                @click.stop="modify(node, data)">
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="deleteBtn el-icon-delete"
                @click.stop="deleteModule(node, data)">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 新增模块 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>模块名称：</span>
          <el-input v-model="name" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入模块名称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">路由名：</span>
          <el-input v-model="url" :maxlength="998" :disabled="dialogType === 'detail'" placeholder="请输入路由名"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">上级模块：</span>
          <el-cascader
            v-model="superModule"
            @change="superModuleSelectChange"
            :show-all-levels="false"
            :disabled="dialogType === 'detail'"
            clearable
            :options="superModuleTree"
            :props="superModuleProps"></el-cascader>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>启用状态：</span>
          <el-select v-model="state" :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">排序：</span>
          <el-input v-model="sort" :maxlength="9" type="number" :disabled="dialogType === 'detail'" placeholder="请输入排序号"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">在菜单中显示：</span>
          <el-select v-model="view" :disabled="dialogType === 'detail'" placeholder="请选择是否显示">
            <el-option
              v-for="item in viewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>是否叶子节点：</span>
          <el-select v-model="leaf" :disabled="dialogType === 'detail'" placeholder="请选择是否叶子节点">
            <el-option
              v-for="item in viewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增模块 弹框 end -->
  </div>
</template>

<script>
// import BasePagination from '@/components/BasePagination'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'moduleMana',
  components: {
    // BasePagination,
  },
  computed: {
    ...mapState([
      'selectedSystem',
    ]),
  },
  data () {
    return {
      dialogType: '',
      // 新增模块参数start
      id: '',
      leaf: '',
      name: '',
      path: '',
      platformId: '',
      sort: '',
      state: '',
      superModule: [],
      url: '',
      view: '',
      // 新增模块参数end
      // 上级模块数据树
      superModuleTree: [],
      superModuleTreeProps: {
        label: 'name',
        children: 'childs',
      },
      // 责任人选择配置项
      usersOptions: [],
      // 上级模块级联选择配置
      superModuleProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'childs',
      },
      // 是否在菜单中显示
      viewOptions: [
        {
          value: true,
          label: '是',
        },
        {
          value: false,
          label: '否',
        },
      ],
      // 平台状态配置项
      stateOptions: [
        {
          value: true,
          label: '启用',
        },
        {
          value: false,
          label: '禁用',
        },
      ],
      addDialogVisible: false,
      addDialogTitle: '',
    }
  },
  watch: {
    // 监听平台选择
    selectedSystem (val) {
      if (val !== '') {
        // 模块树
        this.getSuperModuleTree(val)
        // 用户
        this.getUsersData(val)
      }
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             获取平台树形数据
     * @param {String}          平台id
     * @return {undefined}      无返回值
     */
    getSuperModuleTree (pid) {
      this.$http.post('/api/module/tree', {
        pid: pid,
      }).then(res => {
        if (res.code === 'success') {
          this.superModuleTree = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             获取用户列表
     * @param {String}          平台id
     * @return {undefined}      无返回值
     */
    getUsersData (pid) {
      this.$http.post('/api/user/platform-users', {
        pid: pid,
      }).then(res => {
        if (res.code === 'success') {
          this.usersOptions = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             责任人选择change事件
     * @param {Object}          事件对象
     * @return {undefined}      无返回值
     */
    liablerChange (e) {
      this.usersOptions.map(item => {
        if (item.id === e) {
          this.liabler = item.realname
        }
      })
    },
    /**
     * @description             上级模块选择change事件
     * @param {undefined}       当前选择值
     * @return {undefined}      无返回值
     */
    superModuleSelectChange (e) {
      console.log('上级模块选择change事件', e)
      this.path = e.join('/')
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (node, data) {
      this.dialogType = 'detail'
      this.addDialogTitle = '平台详情'
      this.addDialogVisible = true
      this.id = data.id
      this.leaf = data.leaf
      this.name = data.name
      this.path = data.path
      this.platformId = data.platformId
      this.sort = data.sort
      this.state = data.state
      this.superModule = data.superModule
      this.url = data.url
      this.view = data.view
      let modulePathArr = data.path.split('/').slice(0, -1)
      modulePathArr.map((item, index) => {
        modulePathArr[index] = parseFloat(item)
      })
      this.superModule = modulePathArr
    },
    /**
     * @description             新增模块
     * @param {Object}          节点node
     * @param {Object}          节点模块数据
     * @return {undefined}      无返回值
     */
    add (node, data) {
      console.log('新增模块', data)
      this.dialogType = 'add'
      this.addDialogTitle = '新增模块'
      this.addDialogVisible = true
      if (data) {
        let modulePathArr = data.path.split('/')
        modulePathArr.map((item, index) => {
          modulePathArr[index] = parseFloat(item)
        })
        this.superModule = modulePathArr
      }
    },
    /**
     * @description             删除模块
     * @param {Object}          节点node
     * @param {Object}          节点模块数据
     * @return {undefined}      无返回值
     */
    deleteModule (node, data) {
      console.log('删除模块', data)
      this.$confirm('是否删除模块-' + data.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/api/module/delete', {
          ids: data.id,
        }).then(res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getSuperModuleTree(this.selectedSystem)
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    /**
     * @description             修改模块
     * @param {Object}          节点node
     * @param {Object}          节点模块数据
     * @return {undefined}      无返回值
     */
    modify (node, data) {
      console.log('修改模块', data)
      this.dialogType = 'modify'
      this.addDialogTitle = '修改模块'
      this.addDialogVisible = true

      this.id = data.id
      this.leaf = data.leaf
      this.name = data.name
      this.path = data.path
      this.platformId = data.platformId
      this.sort = data.sort
      this.state = data.state
      this.superModule = data.superModule
      this.url = data.url
      this.view = data.view
      let modulePathArr = data.path.split('/').slice(0, -1)
      modulePathArr.map((item, index) => {
        modulePathArr[index] = parseFloat(item)
      })
      this.superModule = modulePathArr
    },
    /**
     * @description             置空模块信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      this.id = ''
      this.leaf = ''
      this.name = ''
      this.path = ''
      this.platformId = ''
      this.sort = ''
      this.state = ''
      this.superModule = []
      this.url = ''
      this.view = ''
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
      this.clearInfo()
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (!this.superModule.length && !this.selectedSystem) {
        this.$message({
          message: '上级模块为空时，平台为必选项！',
          type: 'error',
        })
        return
      }
      if (this.leaf === '' || this.name === '' || this.selectedSystem === '' || this.state === '') {
        this.$message({
          message: '请填写完整！',
          type: 'error',
        })
        return
      }
      let params = {
        leaf: this.leaf,
        name: this.name,
        // path: this.path,
        platformId: this.selectedSystem,
        superModule: this.superModule[this.superModule.length - 1],
        sort: this.sort,
        state: this.state,
        url: this.url,
        view: this.view,
      }
      if (this.dialogType === 'modify') {
        params.id = this.id
      }

      this.$http.post('/api/module/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addDialogVisible = false
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.clearInfo()
            this.getSuperModuleTree(this.selectedSystem)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
  },
  created () {
    this.setGlobalPlatformSelecter(true)
    if (this.selectedSystem) {
      // 模块树
      this.getSuperModuleTree(this.selectedSystem)
      // 用户
      this.getUsersData(this.selectedSystem)
    }
  },
}
</script>

<style lang="less" scoped>
  .moduleMana{
    width: 100%;
    height: 100%;

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .moduleTree {
        padding: 30px 150px;
        width: calc(100% - 300px);
        height: calc(100% - 60px);
        overflow-y: scroll;
        /deep/ .el-tree {
          .el-tree-node {
            .el-tree-node__content {
              .el-tree-node__expand-icon {
                font-size: 20px;
              }
              .is-leaf {
                opacity: 1;
              }
            }
            .detailBtn {
              margin-left: 50px;
              &:hover {
                color: #83c1ff;
              }
            }
            .addBtn {
              color: #67C23A;
              &:hover {
                color: #a0e07f;
              }
            }
            .modifyBtn {
              color: #E6A23C;
              &:hover {
                color: #f5be6d;
              }
            }
            .deleteBtn {
              color: #F56C6C;
              &:hover {
                color: #f59595;
              }
            }
          }
        }
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 40%;
              margin: 30px 5%;
              .title {
                display: inline-block;
                width: 120px;
                text-align: right;
                .required {
                  color: #F56C6C;
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
              .el-input {
                width: 240px;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
